import { Helmet } from 'react-helmet';
import { FinanceDetailContainer } from '../components/finance-detail.container';

interface FinanceDetailsProps {}

export const FinanceDetails: React.FC<FinanceDetailsProps> = () => {
  return (
    <>
      <Helmet>
      <title>Finance - Finance Detail</title>
      </Helmet>
      <FinanceDetailContainer />
    </>
  );
};
